import { Injectable } from '@angular/core';
import { AsyncSubject, Subject } from 'rxjs';
import { MEAPIService } from '../../services/api/me-api.service';
import { BasicAsyncResponseSuccessHandler, MEDoNothingBasicResponseHandler, ResponseCode } from '../../services/api/me-api-response';
import { Banner, Category, MerchantBanner, Placement } from './me-marketing-banner-bean';

@Injectable({
  providedIn: 'root'
})
export class MeMarketingBannerService {

  private readonly API_GET_WEB_BANNER_INFO = MEAPIService.BASE_URL + '/customer/web-banner/%CATEGORY%/%PLACEMENT%';
  private readonly API_ACCESS_BANNER = MEAPIService.BASE_URL + '/customer/banner/access/%IMAGE_LINK_NAME%';
  private readonly API_GET_RANDOM_MERCHANT_BANNER = MEAPIService.BASE_URL + '/customer/merchantBanner/getRandom';
  private readonly API_GET_MERCHANT_BANNER = MEAPIService.BASE_URL + '/banners/merchant/%BANNER_ID%';
  private readonly API_GET_MERCHANT_BANNER_FOLLOW_LINK = MEAPIService.BASE_URL + '/customer/merchantBanner/follow/%BANNER_ID%';

  constructor(private srvApi: MEAPIService) { }

  public getBanner(category: Category, placement: Placement, merchantId: number | null): AsyncSubject<Banner> {

    if (category == Category.MERCHANT_PAYMENT) {
      let ret = new AsyncSubject<Banner>;
      this.getRandomBanner(merchantId).subscribe((banner: MerchantBanner): void => {
        if (banner) {
          this.getMerchantBanner(banner).subscribe((bannerObj: Banner | null): void => {
            if (bannerObj) {
              ret.next(bannerObj);
              ret.complete();
            } else {
              this.getWebBanner(Category.PAYMENT, placement).subscribe(banner => {
                ret.next(banner);
                ret.complete();
              });
            }
            
          });
        }
        else {
          this.getWebBanner(Category.PAYMENT, placement).subscribe(banner => {
            ret.next(banner);
            ret.complete();
          });
        }
      });
      return ret;
    }
    else {
      return this.getWebBanner(category, placement);
    }
  }

  public getWebBanner(category: Category, placement: Placement): AsyncSubject<Banner> {
    let url = this.API_GET_WEB_BANNER_INFO.replace('%CATEGORY%', category).replace('%PLACEMENT%', placement);
    let ret = new AsyncSubject<Banner>();
    this.srvApi.Get<Banner>(url, [new BasicAsyncResponseSuccessHandler<Banner>(ret), new BasicAsyncResponseSuccessHandler<Banner>(ret, ResponseCode.NO_BANNERS_FOUND)]);
    return ret;
  }

  private getRandomBanner(merchantId: number | null): AsyncSubject<MerchantBanner> {
    let bean = { merchantId };
    let ret = new AsyncSubject<MerchantBanner>();
    this.srvApi.BasicPost(this.API_GET_RANDOM_MERCHANT_BANNER, bean, [new BasicAsyncResponseSuccessHandler<MerchantBanner>(ret)]);
    return ret;
  }

  private getMerchantBanner(banner: MerchantBanner): AsyncSubject<Banner | null> {

    let ret = new AsyncSubject<Banner | null>();
    let url = this.API_GET_MERCHANT_BANNER.replace('%BANNER_ID%', banner.id + '');

    let blobSubject = new Subject<Blob | null>();
    blobSubject.subscribe((blob: Blob | null) => {
      if (blob) {
        const objectURL = URL.createObjectURL(blob);
        const bannerObj: Banner = {
          name: banner.name,
          link: banner.link,
          image: objectURL,
          category: Category.MERCHANT_PAYMENT,
          id: banner.id
        };
        ret.next(bannerObj);
        ret.complete();
      } else {
        ret.next(blob);
        ret.complete();
      }
      
    });

    this.srvApi.DownloadGet(url, '', blobSubject, {useFallback: true});
    return ret;
  }

  accessBanner(banner: Banner): void {
    let url = "";
    if (banner.category == Category.TARGETED) {
      url = this.API_ACCESS_BANNER.replace('%IMAGE_LINK_NAME%', banner.name);
    }
    if (banner.category == Category.MERCHANT_PAYMENT) {
      url = this.API_GET_MERCHANT_BANNER_FOLLOW_LINK.replace('%BANNER_ID%', banner.id + '');
    }
    if (url !== "") {
      this.srvApi.BasicGet(url, [new MEDoNothingBasicResponseHandler(ResponseCode.SUCCESS)])
    }
  }

}
